<main class="cd-main">
  <!-- HEADER -->
  <div class="cd-header-row">
    <div>
      <h1 class="cd-title">Report an issue</h1>
      <p class="cd-subtitle">Let the app support team know what's going on</p>
    </div>
    <div class="header-actions">
      <button
        mat-flat-button
        color="primary"
        class="cd-submit-btn"
        data-testid="issue-reports-send-report"
        [disabled]="form.invalid"
        (click)="submitReport()"
        aria-label="Send report"
      >
        Send report
      </button>
    </div>
  </div>

  <form [formGroup]="form" aria-label="New report form">
    <div class="ce-main">
      <mat-card class="ce-card" appearance="outlined">
        <mat-card-content>
          <h2 class="ce-section-title">Report details</h2>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Title</mat-label>
            <input
              matInput
              formControlName="title"
              placeholder="e.g. Group assignments won't load"
              data-testid="issue-reports-title"
              aria-label="Title"
            />
            <mat-error>Title is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              formControlName="description"
              rows="5"
              placeholder="What were you doing, what did you expect, what happened instead?"
              data-testid="issue-reports-description"
              aria-label="Description"
            ></textarea>
            <mat-error>Description is required</mat-error>
          </mat-form-field>

          <h2 class="ce-section-title">Classification</h2>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Category</mat-label>
            <mat-select
              formControlName="category"
              aria-label="Category"
              data-testid="issue-reports-category"
            >
              <mat-option value="Bug">Bug</mat-option>
              <mat-option value="Outage">Outage</mat-option>
              <mat-option value="Feature Request">Feature Request</mat-option>
              <mat-option value="Access Issue">Access Issue</mat-option>
              <mat-option value="Other">Other</mat-option>
            </mat-select>
            <mat-error>Category is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="ce-field" subscriptSizing="dynamic">
            <mat-label>Priority</mat-label>
            <mat-select
              formControlName="priority"
              aria-label="Priority"
              data-testid="issue-reports-priority"
            >
              <mat-option value="Low">Low</mat-option>
              <mat-option value="Medium">Medium</mat-option>
              <mat-option value="High">High</mat-option>
              <mat-option value="Urgent">Urgent</mat-option>
            </mat-select>
            <mat-error>Priority is required</mat-error>
          </mat-form-field>

          <h2 class="ce-section-title">Attachment (Optional)</h2>

          <label class="ce-upload-dropzone" for="attachment">
            <mat-icon class="ce-upload-icon">upload_file</mat-icon>

            <div class="ce-upload-label">Drag a file here or click to browse</div>

            <div class="ce-upload-hint">PNG, JPG, PDF, DOCX (max 10 MB)</div>

            <input
              id="attachment"
              type="file"
              hidden
              (change)="onFileSelected($event)"
              accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
              data-testid="issue-reports-attachment"
            />
          </label>

          @if (form.controls.attachment.value; as file) {
            <div class="ce-upload-file">
              <mat-icon>attach_file</mat-icon>
              {{ file.name }}
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</main>
